import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import Layout from 'components/Layout/Layout'
import { getLegalDocsServer } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'

const title = 'Samsung Care+ for Business 私隱政策'
const legalType = 'privacy_policy_hk_scpe'

const LegalAgreement = ({ legalDocsResponse }) => {
  return (
    <Layout id={legalType} title={`${title} | Knox Partner Program`}>
      <Container>
        <Row>
          <Col sm={12}>
            <LegalDocs title={title} agreements={legalDocsResponse.data} />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps() {
  const legalDocsResponse = await getLegalDocsServer([legalType])
  if (legalDocsResponse.statusCode !== 200) {
    return {
      redirect: {
        destination: '/en/404',
        permanent: false
      }
    }
  }
  return {
    props: { legalDocsResponse }
  }
}

export default LegalAgreement
